import React, { FC, useState, useEffect } from 'react';
import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import { SCUIContent } from '../../atomic/organisms';
import {
    SCUIDesignCollectiveDrawerContent,
    SCUICustomDataGrid,
    SCUIGeneralDrawer,
    SCUIBreadCrumb,
} from '../../atomic/molecules';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { DesignCollectiveCommand } from '../../services/command';
import { useTranslation } from 'react-i18next';
import TimeHelper from '../../utils/time';
import { enumCommentStatusFlowStatusTrName } from '../../types/enums/status';
import FormControl from '@mui/material/FormControl';
import { downloadExcel } from '../../utils/excelFileHelper';
import { mapDesignCollectiveExportRow } from './DesignCollective.helper';
import PrintIcon from '@mui/icons-material/Print';
import { Box, IconButton, Grid } from '@mui/material';
import Stack from '@mui/material/Stack';
import DoneIcon from '@mui/icons-material/Done';
import InputLabel from '@mui/material/InputLabel';
import { SCUIDateRanger } from '../../atomic/atoms';
import { Visibility } from '@mui/icons-material';
import { DCOL } from './designCollective.classes';

export const DesignCollective: FC<any> = () => {
    const [state, setState] = React.useState({
        right: false,
    });
    const { t } = useTranslation();
    const onDrawerOpen = () => setState({ right: true });
    const onDrawerClose = () => setState({ right: false });
    const [designCollectiveList, setDesignCollectiveList] = React.useState<any>([]);
    const [startDate, setStartDate] = React.useState('');
    const [endDate, setEndDate] = React.useState('');
    const [statusFilter, setStatusFilter] = React.useState('1');
    const [refresh, setRefresh] = useState(false);
    const [designCollectives, setDesignCollectives] = React.useState<any>();
    const [designCollectiveId, setDesignCollectiveId] = React.useState<any>();
    const refreshDesignCollective = () => {
        setRefresh((prevLoading) => !prevLoading);
    };

    useEffect(() => {
        getDesignCollectiveList();
    }, [refresh]);

    const _handlChangeDate = (event: any) => {
        setStartDate(event[0]);
        setEndDate(event[1]);
    };

    const _handleChangeStatus = (event: SelectChangeEvent) => {
        setStatusFilter(event.target.value as string);
    };
    const enumDesignCollectiveStatus: any = {
        1: t('general.waitingForApproval'),
        2: t('general.approved'),
        3: t('general.declined'),
    };
    const downloadExcelHandler = () => {
        const params = {
            CreateDate: [
                {
                    value: startDate,
                    condition: 'gt',
                },
                {
                    value: endDate,
                    condition: 'lt',
                },
            ],
            ...(statusFilter !== '-1' && {
                status: [
                    {
                        value: statusFilter,
                        condition: 'eq',
                    },
                ],
            }),
        };
        DesignCollectiveCommand.PostDesignCollectiveFilterData(params).then((res: any) => {
            if (res.data) {
                const parseData = res.data.map((item: any) =>
                    mapDesignCollectiveExportRow(item, enumCommentStatusFlowStatusTrName)
                );
                downloadExcel({
                    excelDownloadData: parseData,
                    excelDownloadFolderName: 'DesignCollective',
                });
            }
        });
    };

    const columns: ExtendedGridColDef[] = [
        { field: 'id', headerName: 'Id', flex: 1 },
        { field: 'fullName', headerName: t('general.name') + ' - ' + t('general.surname'), flex: 1 },
        { field: 'phoneNumber', headerName: t('general.phoneNumber'), flex: 1, hide: true },
        { field: 'city', headerName: t('general.city'), flex: 1, hide: true },
        { field: 'address', headerName: t('general.address'), flex: 1, hide: true },
        { field: 'instagramUrl', headerName: t('general.name') + ' - ' + t('general.surname'), flex: 1, hide: true },
        { field: 'youtubeUrl', headerName: 'youtube', flex: 1, hide: true },
        { field: 'twitterUrl', headerName: t('general.city'), flex: 1, hide: true },
        { field: 'description', headerName: t('general.address'), flex: 1, hide: true },
        { field: 'attachment', headerName: 'attachment', flex: 1, hide: true },
        { field: 'statusId', headerName: 'attachment', flex: 1, hide: true },
        { field: 'email', headerName: t('general.eMail'), flex: 1 },
        { field: 'createDate', headerName: t('general.date'), flex: 1 },
        { field: 'status', headerName: t('general.status'), flex: 1 },
        {
            field: 'detay',
            headerName: t('general.detail'),
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                const onclick = () => {
                    setDesignCollectives(params.row);
                    setDesignCollectiveId(params.row.id);
                    onDrawerOpen();
                };
                return (
                    <div>
                        <IconButton className={DCOL.inputIconButtonRowDetail} onClick={onclick}>
                            <Visibility sx={{ width: '16px', height: '16px' }} />
                        </IconButton>
                    </div>
                );
            },
        },
    ];

    const getDesignCollectiveList = () => {
        const params = {
            CreateDate: [
                {
                    value: startDate,
                    condition: 'gt',
                },
                {
                    value: endDate,
                    condition: 'lt',
                },
            ],
            ...(statusFilter !== '-1' && {
                status: [
                    {
                        value: statusFilter,
                        condition: 'eq',
                    },
                ],
            }),
        };
        DesignCollectiveCommand.PostDesignCollectiveFilterData(params)
            .then((res: any) => {
                if (res.data) {
                    let parseData = res.data.map((item: any) => {
                        return {
                            id: item.designCollectiveId || '-',
                            fullName: item.fullName || '-',
                            phoneNumber: item.phoneNumber || '-',
                            city: item.city || '-',
                            address: item.address || '-',
                            instagramUrl: item.instagramUrl || '-',
                            youtubeUrl: item.youtubeUrl || '-',
                            twitterUrl: item.twitterUrl || '-',
                            description: item.description || '-',
                            email: item.email || '-',
                            createDate: TimeHelper.formatDateHour(item.createDate) || '-',
                            status: enumDesignCollectiveStatus[item?.status],
                            statusId: item?.status,
                            attachment: item.dCollectiveAttachment || [],
                        };
                    });
                    setDesignCollectiveList(parseData);
                } else {
                    setDesignCollectiveList([]);
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            })
            .finally(() => {});
    };
    return (
        <SCUIContent>
            <SCUIBreadCrumb title={'Design Collective'} componentLink={'DesignCollective'} />
            <Grid className={DCOL.page} container direction="row">
                <SCUIGeneralDrawer
                    open={state['right']}
                    anchor="right"
                    width={'400px'}
                    onClose={(event: any, reason: any) => {
                        if (reason === 'backdropClick') {
                            setState({ right: false });
                        }
                    }}
                >
                    <SCUIDesignCollectiveDrawerContent
                        id={designCollectiveId}
                        detail={designCollectives}
                        onClose={onDrawerClose}
                        onUpdate={refreshDesignCollective}
                    />
                </SCUIGeneralDrawer>
                <Grid className={DCOL.filtersRow} sx={{ width: '100%' }} spacing={2} container>
                    <Grid
                        className={DCOL.fieldDateRange}
                        sx={{ paddingRight: 1 }}
                        size={{
                            xs: 12,
                            md: 3,
                            lg: 3,
                            xl: 3,
                        }}
                    >
                        <Box className={DCOL.dateRangeWrap}>
                            <SCUIDateRanger setDateRange={_handlChangeDate} dateFormat="YYYY-MM-DD" />
                        </Box>
                    </Grid>

                    <Grid
                        size={{
                            xs: 12,
                            md: 3,
                            lg: 3,
                            xl: 3,
                        }}
                    >
                        <FormControl className={DCOL.fieldStatus} fullWidth>
                            <InputLabel id="statusSelectLabel">{t('comments.selectStatus')}</InputLabel>
                            <Select
                                className={DCOL.inputSelectStatus}
                                labelId="statusSelectLabel"
                                fullWidth
                                id="statusSelect"
                                value={statusFilter}
                                label={t('commnts.selectStatus')}
                                onChange={_handleChangeStatus}
                            >
                                <MenuItem value={'-1'}>{t('general.all')}</MenuItem>
                                <MenuItem value={1}>{t('general.waitingForApproval')}</MenuItem>
                                <MenuItem value={2}>{t('general.approved')}</MenuItem>
                                <MenuItem value={3}>{t('general.declined')}</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid
                        size={{
                            md: 3,
                            xs: 3,
                            lg: 3,
                        }}
                    >
                        <Stack className={DCOL.filterActions} direction="row" spacing={2}>
                            <IconButton
                                className={DCOL.inputIconButtonApplyFilter}
                                aria-label="filtrele"
                                onClick={getDesignCollectiveList}
                            >
                                <DoneIcon className="svg_icons" />
                            </IconButton>

                            <IconButton
                                className={DCOL.inputIconButtonExport}
                                aria-label="filter"
                                onClick={downloadExcelHandler}
                            >
                                <PrintIcon className="svg_icons" />
                            </IconButton>
                        </Stack>
                    </Grid>
                </Grid>

                <Box className={DCOL.datagridWrap}>
                    <SCUICustomDataGrid rows={designCollectiveList} columns={columns} />
                </Box>
            </Grid>
        </SCUIContent>
    );
};
